export default function ApprovalWaiting({ onCheckStatus }: { onCheckStatus?: () => void }) {
  return (
    <div className="w-full max-w-lg mx-auto">
      <div className="bg-white rounded-2xl border border-gray-100 shadow-soft p-6 md:p-10 text-center">
        <div className="w-16 h-16 rounded-full bg-dark-teal-50 flex items-center justify-center mx-auto mb-5">
          <i className="ri-time-line text-dark-teal-500 text-2xl animate-pulse" />
        </div>
        <h1 className="text-xl md:text-2xl font-bold text-deep-navy-500 mb-3">
          Profiliniz inceleme için alındı
        </h1>
        <p className="text-sm text-gray-500 leading-relaxed mb-8 max-w-sm mx-auto">
          Başvurunuz güvenlik ve kalite kontrolü için incelenecektir. Onay hedef süresi maksimum 2 saattir.
        </p>

        <div className="grid grid-cols-2 gap-3 mb-8">
          {[
            { icon: 'ri-smartphone-line', label: 'Telefon doğrulandı', done: true },
            { icon: 'ri-file-list-line', label: 'Profil bilgileri alındı', done: true },
            { icon: 'ri-shield-user-line', label: 'Admin onayı bekleniyor', done: false },
            { icon: 'ri-eye-line', label: 'Onay sonrası aktif olacaksınız', done: false },
          ].map((item) => (
            <div
              key={item.label}
              className={`flex items-center gap-2.5 p-3 rounded-xl border text-left ${
                item.done
                  ? 'border-dark-teal-200 bg-dark-teal-50'
                  : 'border-gray-100 bg-off-white'
              }`}
            >
              <i className={`${item.icon} text-sm ${item.done ? 'text-dark-teal-500' : 'text-gray-400'}`} />
              <span className={`text-xs font-medium ${item.done ? 'text-dark-teal-700' : 'text-gray-500'}`}>
                {item.label}
              </span>
            </div>
          ))}
        </div>

        <button
          onClick={onCheckStatus}
          className="w-full py-3.5 rounded-full text-sm font-semibold text-white bg-dark-teal-500 hover:bg-dark-teal-600 transition-colors cursor-pointer"
        >
          Durumumu Gör
        </button>
        <p className="text-xs text-gray-400 mt-4">
          Onay süreci ortalama 15-30 dakika, maksimum 2 saat sürer.
        </p>
      </div>
    </div>
  );
}